import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get, includes, isNull } from 'lodash';

export default class ASQRadio extends React.PureComponent {
  static propTypes = {
    asq: PropTypes.object.isRequired,
    responseType: PropTypes.object.isRequired,
    answer: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  onClick = (e) => {
    const answerId = get(this.props.answer, 'id', null);
    if (e.target.dataset.active === 'true') {
      if (answerId) {
        this.props.onDelete(answerId, {
          asqResponseTypeId: this.props.responseType.id,
          id: answerId });
      }
    } else {
      this.props.onChange(answerId, {
        asqResponseTypeId: this.props.responseType.id,
        answerHandles: [e.target.dataset.handle] }
      );
    }
  }

  render() {
    const { asq, responseType, answer } = this.props;
    const radios = responseType.possibleAnswers.map ( (a, aIdx) => {
      const bActive = !isNull(answer) && includes(answer.answerHandles, a.handle);
      const clsRadio = classNames(
        'o-sp-button o-sp-button--survey',
        { 'o-sp-button--asq': !bActive,
          [`o-sp-button--${asq.type}`]: bActive }
      );
      return (
        <a key={`rr-${responseType.id}-${aIdx}`} className={clsRadio} onClick={this.onClick} data-active={bActive} data-handle={a.handle}>
          {a.label}
        </a>
      );
    })
    return <div className='o-radio-answer'>{radios}</div>;
  }
}
